import styled, { css } from 'styled-components/macro'
import InputLabel from '@material-ui/core/InputLabel'

export const Wrapper = styled.div`
  width: 100%;
`
export const Label = styled(InputLabel)`
  margin-bottom: 8px;
`
export const NomeSecao = styled.h1`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    font-weight: ${theme.font.extraBold};
    font-size: ${theme.font.sizes.medium};
  `}
  margin-bottom: 24px;
`

export const SecaoOpcional = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.gray};
    font-size: ${theme.font.sizes.small};
    font-weight: ${theme.font.normal};
  `}
  margin-left: 6px;
`
